import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const containerHeight = {
  small: 'calc(100% - 541px)',
  default: 'calc(100% - 148px)'
};
export default {
  container: (active: boolean, small: boolean) => ({
    position: 'relative',
    width: '100%',
    height: active ? containerHeight[small ? 'small' : 'default'] : 0,
    mt: active && small ? '32px' : 0,
    textAling: 'left',
    opacity: active ? 1 : 0,
    ...reusables.mainTransition('height, opacity'),
    overflow: 'hidden',
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: 'calc( 100% - 40px)',
      pr: [0, 0, 0, 0, '20px']
    },
    '.swiper-scrollbar': {
      width: '2px',
      right: 0
    },
    '.swiper-scrollbar-drag': {
      backgroundColor: theme.rawColors.darkGrey700
    },
    '.swiper-slide': {
      width: '100%',
      height: 'auto'
    },
    button: {
      width: '100%',
      span: {
        width: '100%'
      }
    }
  }),
  itemList: {
    display: 'flex',
    flexDirection: 'column',
    alingContent: 'start-flex',
    width: '100% !important',
    height: 'auto',
    p: '24px',
    mb: '16px',
    textAlign: 'left',
    border: `1px solid ${theme.rawColors.lightGrey500}`,
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.rawColors.lightGrey700}`
    },
    span: {
      font: theme.fonts.uniform,
      fontSize: theme.fontSizes.smallText,
      width: '100%',
      mb: '2px',
      '&:last-of-type': {
        mb: 0
      }
    }
  },
  accordionItem: {
    width: '100%',
    borderBottom: `1px solid ${theme.rawColors.lightGrey700}`
  },
  accordionHeader: (isOpen: boolean) => ({
    display: 'flex',
    width: '100%',
    borderBottom: isOpen ? 'unset' : `1px solid ${theme.rawColors.darkGrey600}`,
    p: '14px 0 12px 0',
    '&:hover': {
      cursor: 'pointer'
    },
    span: {
      font: theme.fonts.uniformMedium,
      fontSize: theme.fontSizes.text,
      fontwidth: theme.fontWeights.medium,
      color: theme.rawColors.darkGrey600
    },
    button: {
      width: 'auto'
    }
  }),
  addButton: {
    ml: 'auto',
    pr: '10px',
    width: 'auto'
  }
};